import "@mdi/font/css/materialdesignicons.css";
import "@fontsource/barlow/400.css";
import "@fontsource/barlow/500.css";
import "@fontsource/barlow/600.css";
import "@fontsource/barlow/700.css";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/500.css";
import "@/styles/vuetify-settings.scss";
import "@/styles/main.scss";
import { createVuetify, type ThemeDefinition } from "vuetify";
import { aliases, mdi } from "vuetify/iconsets/mdi";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

// Every color comes from public/img/logo.svg: navy and mid blue rings, teal inner ring, grey wordmark
const light: ThemeDefinition = {
    dark: false,
    colors: {
        background: "#eef1f7",
        "on-background": "#26292e",
        surface: "#ffffff",
        "on-surface": "#26292e",
        primary: "#1d4497",
        "on-primary": "#ffffff",
        secondary: "#20689a",
        "on-secondary": "#ffffff",
        accent: "#5ba7c1",
        "on-accent": "#0d1526",
        error: "#ba1a1a",
        "on-error": "#ffffff",
        success: "#1b7d33",
        "on-success": "#ffffff",
        info: "#20689a",
        "on-info": "#ffffff",
        warning: "#9a5400",
        "on-warning": "#ffffff",
    },
};

const dark: ThemeDefinition = {
    dark: true,
    colors: {
        background: "#0d1526",
        "on-background": "#e6ebf4",
        surface: "#152039",
        "on-surface": "#e6ebf4",
        primary: "#7cc4da",
        "on-primary": "#0d1526",
        secondary: "#9db8f5",
        "on-secondary": "#0d1526",
        accent: "#5ba7c1",
        "on-accent": "#0d1526",
        error: "#ff8080",
        "on-error": "#0d1526",
        success: "#6fcf8b",
        "on-success": "#0d1526",
        info: "#9db8f5",
        "on-info": "#0d1526",
        warning: "#f2a93b",
        "on-warning": "#0d1526",
    },
};

export default createVuetify({
    components,
    directives,
    icons: { defaultSet: "mdi", aliases, sets: { mdi } },
    theme: {
        defaultTheme: "system",
        themes: { light, dark },
    },
    defaults: {
        VTextField: { variant: "outlined" },
        VTextarea: { variant: "outlined" },
        VFileInput: { variant: "outlined" },
        VCard: { elevation: 1 },
        VChip: { size: "small" },
    },
});
